import { useEffect, DependencyList } from 'react'

export default function useEffectAsync(effect: () => Promise<void>, inputs: DependencyList): void {
  useEffect(() => {
    effect()
  }, inputs)
}
